import { Component } from '@angular/core';
import { Tabla } from '../../tabla';
import { ActivatedRoute } from '@angular/router';
import { RestService } from 'src/app/_services/rest.service';

@Component({
    template: `
    <div *ngIf="anio">
    <app-tabla [tabla]=getTabla(anio) [postaPorCategoria]="postaPorCategoria" ></app-tabla>
    </div>
` })
export class ResultadosComponent {

    anio: any;

    tabla: Tabla;

    postaPorCategoria: boolean = false;

    constructor(private route: ActivatedRoute, private restService: RestService) {
        this.route.queryParams.subscribe(params => {
            if (params['anio']) {
                this.anio = JSON.parse(params['anio']);
            } else {
                this.anio = (new Date()).getFullYear();
            }
            this.restService.getParam('posta.por.categoria').subscribe(data => {
                this.postaPorCategoria = data.valor.toUpperCase() === 'TRUE';
            })
        });
    }

    getTabla(aa: number): Tabla {
        if (!this.tabla) {
            this.tabla = this.buildTabla(aa);
        }
        return this.tabla
    }

    buildTabla(aa: number): Tabla {
        const resp : Tabla = 
        {
            titulo: 'Resultados ' + aa, 
            endPoint: '/rest-api/public/resultado?anio=' + aa,
            editable: false,
            columnas: [
                {
                    name: 'Categoria',
                    prop: 'categoriaDeporte.categoria',
                    cell: 'nombre',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    width: 120
                },
                {
                    name: 'Deporte',
                    prop: 'categoriaDeporte.deporte',
                    cell: 'nombre',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    width: 130
                },
                {
                    name: 'Sexo',
                    prop: 'sexo',
                    cell: 'nombre',
                    editable: true,
                    resizeable: true,
                    sortable: true,
                    sexo: true,
                    width: 70
                },
                {
                    name: 'Alumno',
                    prop: 'alumno',
                    cell: 'nombre',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    width: 300
                },
                {
                    name: 'Puesto',
                    prop: 'puesto',
                    cell: 'nombre',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    width: 50
                },
                {
                    name: 'Año',
                    prop: 'anio',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    width: 75
                },
                {
                    name: 'Valor',
                    prop: 'valor',
                    editable: false,
                    resizeable: true,
                    sortable: true,
                    icon: true,
                    width: 100
                },
                {
                    name: 'Casa',
                    prop: 'alumno.casa',
                    cell: 'nombre',
                    editable: false,
                    resizeable: true,
                    casa: true,
                    sortable: true,
                    width: 100
                }
            ]
        };
        return resp;
    }

}
